
import { defineComponent } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import Message from 'primevue/message'
import schedulerTimingOutputOutputTabDescriptor from '../SchedulerTimingOutputOutputTabDescriptor.json'

export default defineComponent({
    name: 'scheduler-mail-accordion',
    components: { Accordion, AccordionTab, Checkbox, Dropdown, Message },
    props: { propDocument: { type: Object }, functionalities: { type: Array }, datasets: { type: Array }, jobInfo: { type: Object }, documentWithUniqueMail: { type: Object } },
    emits: ['sendUniqueMailSelected', 'uniqueMailOptionsChanged'],
    data() {
        return {
            schedulerTimingOutputOutputTabDescriptor,
            document: null as any,
            drivers: [],
            fixedRecipientsListDirty: false,
            expressionDirty: false,
            datasetLabelDirty: false,
            datasetParameterDirty: false
        }
    },
    computed: {
        mailToHelp(): string {
            return (this.document.mailtos?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailToMaxLength
        },
        expresionHelp(): string {
            return (this.document.expression?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.expressionMaxLength
        },
        zipMailNameHelp(): string {
            return (this.document.zipMailName?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.zipMailNameMaxLength
        },
        mailSubjectHelp(): string {
            return (this.document.mailsubj?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailSubjectMaxLength
        },
        fileNameHelp(): string {
            return (this.document.containedFileName?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.fileNameMaxLength
        },
        mailTextHelp(): string {
            return (this.document.mailtxt?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.mail.mailTextMaxLength
        },
        uniqueMailEnabledOnOtherDocument(): boolean {
            return this.documentWithUniqueMail && this.propDocument?.id !== this.documentWithUniqueMail?.id && this.documentWithUniqueMail.uniqueMail
        }
    },
    watch: {
        propDocument() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loadDocument()
            this.loadDrivers()
        },
        loadDocument() {
            this.document = this.propDocument
            if (!this.document.useFixedRecipients && !this.document.useExpression && !this.document.useDataset) {
                this.document.useFixedRecipients = false
            }
            this.document.invalid.invalidMail = false
            this.validateDocument(null)
        },
        loadDrivers() {
            const index = this.jobInfo?.documents.findIndex((el: any) => el.label === this.document.label)
            if (index !== -1) {
                this.drivers = this.jobInfo?.documents[index].parameters
            }
        },
        removeDocumentExpressionAndDatasets() {
            this.validateDocument(null)
            if (this.document.useFixedRecipients) {
                this.resetExpression()
                this.resetFolderDataset()
            }
        },
        removeDocumentFixedRecipientsAndDatasets() {
            this.validateDocument(null)
            if (this.document.useExpression) {
                this.resetFixedRecipients()
                this.resetFolderDataset()
            }
        },
        removeDocumentFixedRecipientsAndExpression() {
            this.validateDocument(null)
            if (this.document.useDataset) {
                this.resetFixedRecipients()
                this.resetExpression()
            }
        },
        resetFixedRecipients() {
            if (this.document.useFixedRecipients) {
                this.document.useFixedRecipients = false
                delete this.document.mailtos
            }
        },
        resetExpression() {
            if (this.document.useExpression) {
                this.document.useExpression = false
                delete this.document.expression
            }
        },
        resetFolderDataset() {
            if (this.document.useDataset) {
                this.document.useDataset = false
                delete this.document.useDataset.datasetLabel
                delete this.document.useDataset.parameters
            }
        },
        validateDocument(dirty: string | null) {
            if (dirty) {
                this[dirty] = true
                this.uniqueMailChanged()
            }

            const fixedRecipientsListInvalid = this.document.useFixedRecipients && (!this.document.mailtos || (this.document.mailtos.length === 0 && !this.uniqueMailEnabledOnOtherDocument))
            const expressionInvalid = this.document.useExpression && (!this.document.expression || (this.document.expression.length === 0 && !this.uniqueMailEnabledOnOtherDocument))
            const datasetInvalid = this.document.useDataset && (!this.document.datasetLabel || this.document.datasetLabel?.length === 0 || !this.document.datasetParameter || this.document.datasetParameter?.length === 0) && !this.uniqueMailEnabledOnOtherDocument

            this.document.invalid.invalidMail = fixedRecipientsListInvalid || expressionInvalid || datasetInvalid
        },
        onSendUniqueMailChanged() {
            this.$emit('sendUniqueMailSelected', this.document)
        },
        uniqueMailChanged() {
            if (this.documentWithUniqueMail && this.document?.id === this.documentWithUniqueMail.id && this.documentWithUniqueMail.uniqueMail) this.$emit('uniqueMailOptionsChanged', this.documentWithUniqueMail)
        }
    }
})
